import type { ReactNode } from "react";

export const SITE_NAME = "瓜核社";

export const NAV = [
  { label: "可信档案", href: "#cases" },
  { label: "取证时间线", href: "#timeline" },
  { label: "求证进行中", href: "#pending" },
  { label: "核验流程", href: "#process" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export type Verdict = "实锤" | "存疑" | "辟谣";

export function verdictStyle(v: string) {
  switch (v) {
    case "实锤":
      return {
        pill: "bg-accent-500 text-background-50",
        soft: "bg-accent-100 text-accent-900 border-accent-200",
        bar: "bg-accent-500",
        label: "text-accent-700",
        dot: "bg-accent-500",
      };
    case "辟谣":
      return {
        pill: "bg-primary-500 text-background-50",
        soft: "bg-primary-100 text-primary-900 border-primary-200",
        bar: "bg-primary-500",
        label: "text-primary-700",
        dot: "bg-primary-500",
      };
    default:
      return {
        pill: "bg-secondary-600 text-background-50",
        soft: "bg-secondary-100 text-secondary-900 border-secondary-200",
        bar: "bg-secondary-500",
        label: "text-secondary-800",
        dot: "bg-secondary-500",
      };
  }
}

export function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: {
  eyebrow: string;
  title: ReactNode;
  desc?: string;
  align?: "left" | "center";
}) {
  const alignCls =
    align === "center"
      ? "text-center items-center"
      : "text-left items-start";
  return (
    <div className={`flex flex-col gap-3 ${alignCls}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-background-100 border border-background-200 px-3 py-1 text-xs text-secondary-800 whitespace-nowrap">
        <i className="ri-sparkling-2-line text-primary-500" />
        {eyebrow}
      </span>
      <h2 className="text-2xl md:text-4xl leading-tight text-foreground-950 max-w-2xl">
        {title}
      </h2>
      {desc ? (
        <p className="text-sm md:text-base text-foreground-600 max-w-xl leading-relaxed">
          {desc}
        </p>
      ) : null}
    </div>
  );
}

export function SectionShell({
  id,
  children,
  className = "",
}: {
  id?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section id={id} className={`py-14 md:py-20 ${className}`}>
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">{children}</div>
    </section>
  );
}